/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./pc-carousel.vue?vue&type=template&id=b57bf792&scoped=true"
import script from "./pc-carousel.vue?vue&type=script&lang=js"
export * from "./pc-carousel.vue?vue&type=script&lang=js"
import style0 from "./pc-carousel.vue?vue&type=style&index=0&id=b57bf792&prod&lang=scss&scoped=true"
import style1 from "./pc-carousel.vue?vue&type=style&index=1&id=b57bf792&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b57bf792",
  null
  
)

export default component.exports
import QTabs from 'quasar/src/components/tabs/QTabs.js';
import QTab from 'quasar/src/components/tabs/QTab.js';
import qInstall from "../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QTabs,QTab});
